import React, { useContext, useState } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { Form as FinalForm, Field } from "react-final-form";
import { Form, Button, Grid, Segment } from "semantic-ui-react";
import DateInput from "../../app/common/form/DateInput";
import { IPayrollFilter } from "../../app/models/trackPayroll";
import {
  payrollDocumentTypesOptions,
  processResultCode,
} from "../../app/util/listOfValoursOptions";
import SelectInput from "../../app/common/form/SelectInput";
import { observer } from "mobx-react-lite";
import SelectInputOnSearchChange from "../../app/common/form/SelectInputOnSearchChange";

const FilterForm = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    filter,
    setFilter,
    btFilter,
    getEmployeesAutocomplete,
    employeesAutocomplete,
    documentNumberAutocomplete,
    getDocumentNumberAutocomplete,
  } = rootStore.trackPayrollStore;

  const [filterForm] = useState<IPayrollFilter>({
    employeeIdentification: filter.employeeIdentification,
    documentID: filter.documentID,
    payrollType: filter.payrollType,
    processState: filter.processState,
    issueDateFrom: filter.issueDateFrom,
    issueDateTo: filter.issueDateTo,
  });

  const handleFinalFormSubmit = (values: any) => {    
    setFilter(values);
  };

  const handleEmployeeIdentification = async (value: any) => {
    getEmployeesAutocomplete(value);
  };

  const handleDocumentNumber = async (value: any) => {
    getDocumentNumberAutocomplete(value);
  };

  return (
    <Segment className="grayborder">
      <FinalForm
        initialValues={filterForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="filter">
              <Grid relaxed doubling columns={2}>
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <label>Empleado</label>
                    <Field
                      name="employeeIdentification"
                      value={filterForm.employeeIdentification}
                      component={SelectInputOnSearchChange}
                      search={true}
                      autoComplete="off"
                      options={employeesAutocomplete}
                      onSearchChange={handleEmployeeIdentification}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <label>Número Documento</label>
                    <Field
                      autoComplete="off"
                      name="documentID"
                      value={filterForm.documentID}
                      component={SelectInputOnSearchChange}
                      search={true}
                      options={documentNumberAutocomplete}
                      onSearchChange={handleDocumentNumber}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <label>Tipo de nómina</label>
                    <Field
                      name="payrollType"
                      component={SelectInput}
                      search={true}
                      defaultValue={-1}
                      options={payrollDocumentTypesOptions}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <label>Estado</label>
                    <Field
                      name="processState"
                      component={SelectInput}
                      search={true}
                      defaultValue={-1}
                      options={processResultCode}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <label>Fecha emisión (dd/mm/yyyy)</label>
                    <Form.Group widths="equal">
                      <Field
                        name="issueDateFrom"
                        placeholder="Desde"
                        value={filterForm.issueDateFrom}
                        component={DateInput}
                      />
                      <Field
                        name="issueDateTo"
                        placeholder="Hasta"
                        value={filterForm.issueDateTo}
                        component={DateInput}
                      />
                    </Form.Group>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <br />
              <Button
                loading={btFilter}
                disabled={btFilter}
                className="ui primary button filterbutton"
                color="blue"
                type="submit"
                content="Buscar"
              />
            </div>
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(FilterForm);
